import { Popover } from '@byecode/ui'
import type { Veins } from '@lighthouse/core'
import { BACKGROUND_TYPE } from '@lighthouse/core'
import { FilledInput, PopoverDropdownWithClose, VeinsController } from '@lighthouse/shared'
import isDeepEqual from 'fast-deep-equal'
import React, { useCallback } from 'react'

import { useColorSystemAction } from '@/hooks/useColorSystemAction'
import { useGetColorVariableOptions } from '@/hooks/useGetColorVariableOptions'

interface VeinsFieldProps {
    value: Veins | undefined
    onChange: (val: Veins) => void

    customViewDsId?: string
}

export const VeinsField: React.FC<VeinsFieldProps> = ({ value, onChange, customViewDsId }) => {
    const colorSystemMethods = useColorSystemAction()

    const variableTypeOption = useGetColorVariableOptions({
        customViewDsId
    })

    const getValue = useCallback((val: Veins | undefined) => {
        if (val?.color) {
            return val?.color
        }
        if (val?.value) {
            return 'transparent'
        }
    }, [])

    return (
        <Popover width={300} position="left-start" withinPortal autoUpdate={false} offsetOptions={168}>
            <Popover.Target>
                <FilledInput
                    value={{ type: BACKGROUND_TYPE.color, color: getValue(value) }}
                    onClear={() => {
                        onChange({
                            color: '',
                            value: '',
                            strokeWidth: 1,
                            size: 1
                        })
                    }}
                    style={{ width: 180 }}
                    variableTypeOption={variableTypeOption}
                />
            </Popover.Target>
            <PopoverDropdownWithClose title="纹理">
                <VeinsController
                    name="veins"
                    value={value}
                    onChange={val => {
                        if (isDeepEqual(val, value)) {
                            return
                        }
                        onChange(val)
                    }}
                    variableTypeOption={variableTypeOption}
                    {...colorSystemMethods}
                />
            </PopoverDropdownWithClose>
        </Popover>
    )
}
